
import {Component, Provide, Vue} from 'vue-property-decorator';

@Component({})
export default class AlertDialogWrapper extends Vue {

  @Provide('agree') private provideAgree: any = this.agree;
  @Provide('cancel') private provideCancel: any = this.cancel;

  private dialog: boolean = false;
  private resolve: any = null;
  private reject: any = null;

  private options: any = {
    width: 400,
    zIndex: 200,
  };

  public open(options) {
    this.dialog = true;
    this.options = Object.assign(this.options, options);
    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  private agree() {
    this.resolve(true);
    this.dialog = false;
  }

  private cancel() {
    this.resolve(false);
    this.dialog = false;
  }

}
